import { API } from 'aws-amplify';

export const configurations = (body) =>
{
	return API.post('userManagement', '/configurations', { body });
};

export const getConfigurations = (queryStringParameters) =>
{
	return API.get('userManagement', '/configurations/network', { queryStringParameters });
};

export const FilterData = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/connectionFilter', { queryStringParameters });
};

export const getConnectionsData = (queryStringParameters:any) =>
{
	return API.get('connectionManagement', '/getConnections', { queryStringParameters });
};

export const getFollowData = (queryStringParameters:any) =>
{
	return API.get('connectionManagement', '/getFollowRelationList', { queryStringParameters });
};

export const getBlockData = (queryStringParameters:any) =>
{
	return API.get('connectionManagement', '/getBlockCompanyList', { queryStringParameters });
};

export const getActivity = (queryStringParameters:any) =>
{
	return API.get('connectionManagement', '/getActivity', { queryStringParameters });
};

export const CompanyFollowList = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/getFollowListByCompany', { queryStringParameters });
};

export const getRelationManagers = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/getRelationManagersList', { queryStringParameters });
};

export const getDefaultRms = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/getDefaultRMs', { queryStringParameters });
};

export const UpdateRelationConnection = (body:any) =>
{
	return API.put('connectionManagement', '/connection', { body });
};
export const getCmpnyExtendedNetwrks = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/getExtendedNetwork', { queryStringParameters });
};